import { render } from "./BalanceGroupControl.vue?vue&type=template&id=fcad6b04"
import script from "./BalanceGroupControl.vue?vue&type=script&lang=js"
export * from "./BalanceGroupControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__